import { Injectable } from '@angular/core';

@Injectable()
export abstract class AbstractAlertService {
  public abstract showInfoAlert(message: unknown, duration?: number): Promise<void>;
  public abstract showSuccessAlert(message: unknown, duration?: number): Promise<void>;
  public abstract showErrorAlert(message: unknown, duration?: number): Promise<void>;
  public abstract clearAlerts(): Promise<void>;
}
